import { render, staticRenderFns } from "./selectBatch.vue?vue&type=template&id=04e20237&"
import script from "./selectBatch.vue?vue&type=script&lang=js&"
export * from "./selectBatch.vue?vue&type=script&lang=js&"
import style0 from "./selectBatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports